import React from "react";
import ChildHeaderLayout from "./childHeaderLayout";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";
import config from "configs/config";
import Skeleton from "@mui/material/Skeleton";

const StockChildLayoutWraaper = ({ pageName, icon, deIcon }) => {

  const fetchCategoryData = async () => {
    const payload = {
      limit: 30,
      location: ["BBM Stock", "BBS Stock", "BBM Customer Stock", "BBS Customer Stock", "Headquarters Stock"],
      order: "asc",
      page: 1,
      searchTerm: "",
      sortBy: ""
    }
    const response = await apiClient.post(`/api/v1/stocks/getStockCategory`,payload);
    console.log("Incoming Data-------->", response?.data);
    return response?.data;
  };

  const { isLoading, data } = useQuery({
    queryKey: ["stockCountData"],
    queryFn: fetchCategoryData,
    cacheTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    initialDataUpdatedAt: 0,
  });


  if (isLoading) {
    return <Skeleton animation="wave" height={60} width="20%" sx={{ margin: 0, padding: 0, marginLeft: "20px" }} />;
  }

  return <ChildHeaderLayout pageName={pageName} icon={icon} deIcon={deIcon} categoryCountWithDesgin={data || {}}/>;
};

export default StockChildLayoutWraaper;
